// extracted by mini-css-extract-plugin
module.exports = {"label":"TimeSelectionDropdown_label__2jZqI h6 d-block text-center","select":"TimeSelectionDropdown_select__9gaJU","dropdown":"TimeSelectionDropdown_dropdown__2Gvby"};